import React from 'react';
import { CHECKOUT_URL } from '../data/content';
import { trackPixelEvent } from '../utils/metaPixel';
type CtaButtonProps = {
  children: React.ReactNode;
  size?: 'md' | 'lg';
  className?: string;
  location?: string;
};
export function CtaButton({
  children,
  size = 'md',
  className = '',
  location = 'sales-page'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-5 py-4 text-lg sm:px-8 sm:py-5 sm:text-2xl' : 'px-4 py-3 text-sm sm:px-6 sm:py-4 sm:text-lg';
  const handleClick = () => {
    trackPixelEvent('InitiateCheckout', {
      content_name: 'Megapack Constructor Elite 360',
      content_ids: ['megapack-constructor-elite-360'],
      content_type: 'product',
      value: 25,
      currency: 'USD',
      source_block: location
    });
  };
  return <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleClick} className={`inline-flex items-center justify-center gap-3 rounded-sm bg-safety font-display uppercase tracking-wide text-safety-ink transition-[transform,background-color] duration-150 ease-out hover:bg-safety-dark active:translate-y-1 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-safety ${sizing} ${className}`} data-id="element-59" data-mp="19ajrx595o5xq">
      {children}
    </a>;
}